import { render, staticRenderFns } from "./placard_shop_car.vue?vue&type=template&id=45156f08&scoped=true"
import script from "./placard_shop_car.vue?vue&type=script&lang=js"
export * from "./placard_shop_car.vue?vue&type=script&lang=js"
import style0 from "./placard_shop_car.vue?vue&type=style&index=0&id=45156f08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45156f08",
  null
  
)

export default component.exports